import styled from "styled-components";

export const Container = styled.div`
	width: 90rem;
	max-width: 100%;
	padding: 0 1.5625rem;
	margin: 0 auto;
`;